export function afterStore(controller) {
  let isRestoringScroll = false;
  let shouldContinueLoading = false;
  
  controller.on('init', async ({ controller }, next) => {
    controller.log.debug('initialization...');
    
    // Restore scroll position if returning from product page
    if (typeof window !== 'undefined' && window.sessionStorage) {
      const checkAndRestoreScroll = () => {
        if (isRestoringScroll) return;
        
        const savedScrollPos = sessionStorage.getItem('searchspring_scroll_position');
        const savedPageStr = sessionStorage.getItem('searchspring_page_number');
        const savedUrl = sessionStorage.getItem('searchspring_saved_url');
        
        // Only restore scroll position if we're on a collection page (collections/{collection})
        const currentPath = window.location.pathname;
        const isCollectionPage = /^\/collections\/[^\/]+/.test(currentPath);
        
        // Also verify the saved URL is a collection page
        let savedUrlIsCollection = false;
        if (savedUrl) {
          try {
            const savedUrlObj = new URL(savedUrl);
            savedUrlIsCollection = /^\/collections\/[^\/]+/.test(savedUrlObj.pathname);
          } catch (e) {
            // If URL parsing fails, skip restoration
          }
        }
        
        if (savedScrollPos !== null && isCollectionPage && savedUrlIsCollection) {
          isRestoringScroll = true;
          
          shouldContinueLoading = true;
          
          // Check if we need to load more pages
          const currentPage = controller.store.pagination?.current?.number || 1;
          const savedPage = savedPageStr ? parseInt(savedPageStr, 10) : 1;
          
          if (savedPage > currentPage && controller.store.pagination?.next?.url) {
            // Trigger first load more - this will update the URL naturally
            controller.store.pagination.next.url.go({ history: 'replace' });
          } else {
            // No need to load more, just restore scroll
            // But first, update URL if needed to match saved page
            if (savedPage > 1 && savedPage === currentPage) {
              // We're on the right page, update URL to match saved URL if different
              try {
                const savedUrlObj = new URL(savedUrl);
                const currentUrlObj = new URL(window.location.href);
                const savedPageParam = savedUrlObj.searchParams.get('p');
                const currentPageParam = currentUrlObj.searchParams.get('p');
                
                if (savedPageParam && savedPageParam !== currentPageParam) {
                  // Update URL to include page parameter
                  const newUrl = new URL(window.location.href);
                  newUrl.searchParams.set('p', savedPageParam);
                  window.history.replaceState(null, '', newUrl.toString());
                }
                
              } catch (e) {
                // If URL parsing fails, continue without URL update
              }
            }

            
            shouldContinueLoading = false;
            setTimeout(() => {
              const scrollPos = parseInt(savedScrollPos, 10);
              window.scrollTo({ top: scrollPos, behavior: 'auto' });
              sessionStorage.removeItem('searchspring_scroll_position');
              sessionStorage.removeItem('searchspring_page_number');
              sessionStorage.removeItem('searchspring_total_pages');
              sessionStorage.removeItem('searchspring_saved_url');
              isRestoringScroll = false;
            }, 100);
          }
        }
      };
      
      // Try to restore on load
      if (document.readyState === 'complete') {
        setTimeout(checkAndRestoreScroll, 100);
      } else {
        window.addEventListener('load', () => {
          setTimeout(checkAndRestoreScroll, 100);
        });
      }
      
      // Also check on pageshow (back/forward navigation)
      window.addEventListener('pageshow', (event) => {
        if (event.persisted) {
          setTimeout(checkAndRestoreScroll, 100);
        }
      });
    }
    
    await next();
  });
  
  // Listen for afterStore events to continue loading pages if needed
  controller.on('afterStore', async ({ controller }, next) => {
    if (shouldContinueLoading && isRestoringScroll && typeof window !== 'undefined' && window.sessionStorage) {
      const currentPage = controller.store.pagination?.current?.number || 1;
      const savedPageStr = sessionStorage.getItem('searchspring_page_number');
      const savedPage = savedPageStr ? parseInt(savedPageStr, 10) : 1;
      const savedUrl = sessionStorage.getItem('searchspring_saved_url');
      
      if (currentPage < savedPage && controller.store.pagination?.next?.url) {
        // Continue loading more pages
        setTimeout(() => {
          controller.store.pagination.next.url.go({ history: 'replace' });
        }, 100);
      } else {
        // We've loaded all needed pages, ensure URL is correct and restore scroll position
        shouldContinueLoading = false;
        
        // Ensure URL matches saved URL if we're on the correct page
        if (currentPage === savedPage && savedPage > 1 && savedUrl) {
          try {
            const savedUrlObj = new URL(savedUrl);
            const currentUrlObj = new URL(window.location.href);
            const savedPageParam = savedUrlObj.searchParams.get('p');
            const currentPageParam = currentUrlObj.searchParams.get('p');
            
            // Only update URL if page parameter is missing or different
            if (savedPageParam && savedPageParam !== currentPageParam) {
              const newUrl = new URL(window.location.href);
              newUrl.searchParams.set('p', savedPageParam);
              window.history.replaceState(null, '', newUrl.toString());
            }
          } catch (e) {
            // If URL parsing fails, continue without URL update
          }
        }
        
        setTimeout(() => {
          const savedScrollPos = sessionStorage.getItem('searchspring_scroll_position');
          if (savedScrollPos) {
            const scrollPos = parseInt(savedScrollPos, 10);
            window.scrollTo({ top: scrollPos, behavior: 'auto' });
            sessionStorage.removeItem('searchspring_scroll_position');
            sessionStorage.removeItem('searchspring_page_number');
            sessionStorage.removeItem('searchspring_total_pages');
            sessionStorage.removeItem('searchspring_saved_url');
          }
          isRestoringScroll = false;
        }, 300);
      }
    }
    
    await next();
  });

  controller.on('afterStore', async ({ controller: { store } }, next) => {
    mutateFacets(store.facets);
    mutateFilters(store.filters);

    await next();
  });

  // log the store
  controller.on('afterStore', async ({ controller }, next) => {
    controller.log.debug('store', controller.store.toJSON());
    await next();
  });

  // controller.on("afterStore", scrollToTop);
}

function mutateFacets(facets) {
  const isUS = window.Resources?.country_code === 'US';
  const isCanada = window.Resources?.country_code === 'CA';

  facets.forEach(facet => {
    // Hide USD Pricing in non-US countries
    if (facet.field === 'ss_price' && !isUS) {
    }

    // Hide CAD pricing in non-CA countries
    if (facet.field === 'variant_mfield_cql_price_cad' && !isCanada) {
      facet.display = 'none';
    }
  });
}

function mutateFilters(filters) {
  filters.forEach(filter => {
    const singleValueToggleFacetNames = window.ssConfig?.singleValueFacets?.split(',');

    if (singleValueToggleFacetNames?.includes(filter.facet.field)) {
      filter.value.label = filter.facet.label;
    }
  });
}

function mutateResults(results) {
  // for (let result of results) {
  //   result.mappings.core.name += "++";
  // }
}

// export async function scrollToTop(search, next) {
//   window.scroll({ top: 0, left: 0, behavior: "smooth" });
//   await next();
// }
